import React from 'react';
import { motion } from 'framer-motion';
import { Settings2, Save, X } from 'lucide-react';
import { Button } from '../ui/button';

// Single fixed action bar (mobile: above bottom nav; desktop: bottom, offset by the sidebar)
const SelectionBar = ({ count, onConfigure, onSave, onClear }) => {
  if (count === 0) return null;
  const plural = count > 1 ? 's' : '';
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
      className="fixed bottom-[72px] md:bottom-4 left-2 right-2 md:left-[calc(16rem+1rem)] md:right-4 z-40 bg-white border-2 border-neon-pink/40 shadow-xl rounded-2xl px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3"
      data-testid="selection-bar" role="region" aria-label="Sélection de mises en place">
      <span className="text-gray-900 font-semibold text-sm sm:flex-1" data-testid="selection-count">
        {count} mise{plural} en place sélectionnée{plural}
      </span>
      <div className="grid grid-cols-3 sm:flex gap-2">
        <Button variant="outline" onClick={onConfigure} className="h-11 rounded-full border-gray-300 text-gray-800 text-sm" data-testid="selection-configure-btn">
          <Settings2 size={16} className="mr-1.5" />Paramétrer
        </Button>
        <Button onClick={onSave} className="h-11 rounded-full bg-neon-pink hover:bg-neon-pink/90 text-gray-900 font-semibold text-sm" data-testid="selection-save-btn">
          <Save size={16} className="mr-1.5" />Enregistrer {count} tâche{plural}
        </Button>
        <Button variant="ghost" onClick={onClear} className="h-11 rounded-full text-gray-600 text-sm" data-testid="selection-clear-btn">
          <X size={16} className="mr-1.5" />Annuler la sélection
        </Button>
      </div>
    </motion.div>
  );
};

export default SelectionBar;
